module.exports = __webpack_public_path__ + "static/img/home_showmore_photo1@2x.4a3663f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/productCase/home_showmore_photo1@2x.png
// module id = 2PdX
// module chunks = 0